import axios from 'axios'
import router from '@/router'
import debounce from 'lodash.debounce'

const state = {
	events: {
		results: []
	},
	countries: [],
	activeCountryCode: [],
	cities: [],
	activeCities: [],
	name: [],
	activeNames: [],
	activeNamesCodes: [],
	breeds: [],
	activeBreedsId: [],
	activeRank: '',
	point: '',
	distance: '',
	activeCity: '',
	startDate: '',
	endDate: '',
	dateText: '',
	routeParams: {},
	allowedLocation: false
}

const getters = {
	isEventCountryActive (state) {
		return item => state.activeCountryCode.some(country => country === item)
	},
	isRankActive (state) {
		return item => state.activeRank === item
	},
	isBreedActive (state) {
		return item => state.activeBreedsId.some(breed => breed === item.id)
	},
	isJudgesNameActive (state) {
		return item => state.activeNames.some(name => name === item)
	},
	activeCountries (state) {
		return state.activeCountryCode.reduce((acc, code) => {
			const country = state.countries.find(country => country.code === code)
			return country ? [ ...acc, country ] : acc
		}, [])
	},
	activeBreeds (state) {
		return state.activeBreedsId.reduce((acc, id) => {
			const breed = state.breeds.find(breed => breed.id === id)
			return breed ? [ ...acc, breed ] : acc
		}, [])
	},
	isAnyFilterSelected (state, getters) {
		return getters.activeCountries[0] ||
			state.activeNames[0] ||
			getters.activeBreeds[0] ||
			state.activeCity ||
			state.activeRank ||
			state.distance ||
			state.dateText
	}
}

const mutations = {
	clearEventsFilters (state) {
		state.activeRank = ''
		state.activeCountryCode = []
		state.activeCities = []
		state.activeNames = []
		state.activeNamesCodes = []
		state.activeBreeds = []
		state.activeBreedsId = []
		state.startDate = ''
		state.endDate = ''
	},
	setEvents (state, events) {
		state.events = events
	},
	addRank (state, rank) {
		state.activeRank = rank
	},
	removeRank (state) {
		state.activeRank = ''
	},
	setCountries (state, country) {
		state.countries = country
	},
	addEventsCountry (state, code) {
		state.activeCountryCode.push(code)
	},
	removeEventsCountry (state, code) {
		state.activeCountryCode = state.activeCountryCode.filter(item => item !== code)
	},
	setCities (state, item) {
		state.distance = item.distance
		state.point = item.point
		state.activeCity = item.name
	},
	removeCity (state) {
		state.distance = ''
		state.point = ''
		state.activeCity = ''
	},
	setNames (state, name) {
		state.name = name
	},
	addJudgeName (state, name) {
		state.activeNames.push(name)
		state.activeNamesCodes.push(name.id)
	},
	removeJudgeName (state, item) {
		state.activeNames = state.activeNames.filter(name => name !== item)
		state.activeNamesCodes = state.activeNamesCodes.filter(id => id !== item.id)
	},
	setBreeds (state, breed) {
		state.breeds = breed
	},
	addBreed (state, breed) {
		state.activeBreedsId.push(breed)
	},
	removeBreed (state, item) {
		state.activeBreedsId = state.activeBreedsId.filter(id => id !== item)
		router.push({ name: 'EventsList', params: { userId: 123 } })
	},
	setRange (state, item) {
		state.startDate = item.startDate
		state.endDate = item.endDate
	},
	resetRange (state) {
		state.startDate = ''
		state.endDate = ''
	},
	updateDateText (state, text) {
		state.dateText = text || ''
	},
	setRouteParams (state, params) {
		state.routeParams = params
	},
	allowLocation (state) {
		state.allowedLocation = true
	}
}

const actions = {
	fetchEvents: debounce((context, index) => {
		const qs = require('qs')
		const config = {
			params: {
				rank: state.activeRank,
				country: state.activeCountryCode,
				judge: state.activeNamesCodes,
				breed: state.activeBreedsId,
				distance: state.distance,
				point: state.point,
				date_0: state.startDate,
				date_1: state.endDate,
				date_to_0: state.startDate,
				date_to_1: state.endDate,
				page: index
			},
			paramsSerializer (params) {
				Object.keys(params).forEach(param => {
					if (!params[param]) {
						delete params[param]
					}
				})
				return qs.stringify(params, {indices: false})
			}
		}
		return axios.get('/api/events/', config)
			.then(response => {
				const events = { ...response.data, currentPage: index || 1 }
				context.commit('setEvents', events)

				return events.results
			})
			.catch(error => {
				console.error(error)
			})
	}, 0),
	fetchCountries ({ commit, state }) {
		return axios.get('/api/places/countries/autocomplete?fci_europe_member=true', {
		})
			.then(response => {
				const countries = response.data
				commit('setCountries', countries)
			})
			.catch(error => {
				console.error(error)
			})
	},
	fetchCities ({ commit }) {
		axios.get('/api/places/cities/autocomplete/', {
		})
			.then(response => {
				const cities = response.data
				commit('setCities', cities)
			})
			.catch(error => {
				console.error(error)
			})
	},
	fetchNames ({ commit }) {
		axios.get('/api/judges/autocomplete/', {
		})
			.then(response => {
				const name = response.data
				commit('setNames', name)
			})
			.catch(error => {
				console.error(error)
			})
	},
	fetchBreeds ({ commit }) {
		return axios.get('/api/dogs/subgroup/autocomplete/', {
		})
			.then(response => {
				const breed = response.data
				commit('setBreeds', breed)
			})
			.catch(error => {
				console.error(error)
			})
	}
}

export default {
	state,
	getters,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/events.js